import {
  Box,
  Button,
  ComponentMultiStyleConfig,
  HStack,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Text,
  useMultiStyleConfig,
} from "@chakra-ui/react";
import React from "react";
import {
  ComponentStyleProps,
  componentStylePropsOf,
} from "../../../../lib/styles/props/component-style-props";

export type CMModalJsonDifferenceProps = {
  isOpen?: boolean;
  labelHeader?: { before: string; after: string };
  labelBody?: { before: string; after: string };

  /**
   * キャンセルボタンの表示に使用
   */
  labelCancelButton?: string;
  CancelButtonColorScheme?: string;

  /**
   * キャンセルしたときのコールバック。
   */
  onCancel?: () => void;
} & ComponentStyleProps;

/**
 * 変更前後JSONを表すモーダルを表示するコンポーネント
 */
export const CMModalJsonDifference = ({
  isOpen = false,
  labelHeader,
  labelBody,

  labelCancelButton,
  CancelButtonColorScheme = "gray",

  onCancel,

  sx,
  ...rest
}: CMModalJsonDifferenceProps) => {
  const styles = useMultiStyleConfig("CMModalJsonDifferenceStyles");

  const _onCancel = () => {
    // モーダルを閉じる
    onCancel?.();
  };

  return (
    <Box sx={{ ...styles, ...sx }} {...rest}>
      {/*Modalに対してsxは設定できない。*/}
      <Modal
        isOpen={isOpen}
        onClose={_onCancel}
        size={"3xl"}
        scrollBehavior={"inside"}
      >
        <ModalOverlay />
        <ModalContent sx={styles.modalContent}>
          <ModalBody sx={styles.modalBody}>
            <HStack sx={styles.hStack}>
              <Box sx={styles.jsonContainer}>
                <Box sx={styles.labelHeader}>{labelHeader?.before}</Box>
                <Box sx={styles.labelBody}>{labelBody?.before}</Box>
              </Box>
              <Box sx={styles.jsonContainer}>
                <Text sx={styles.labelHeader}>{labelHeader?.after}</Text>
                <Text sx={styles.labelBody}>{labelBody?.after}</Text>
              </Box>
            </HStack>
          </ModalBody>

          <ModalFooter>
            <Button
              colorScheme={CancelButtonColorScheme}
              onClick={_onCancel}
              sx={styles.cancelButton}
            >
              {labelCancelButton}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export const CMModalJsonDifferenceStyles: ComponentMultiStyleConfig = {
  parts: [
    "modalContent",
    "modalBody",
    "jsonContainer",
    "hStack",
    "labelHeader",
    "labelBody",
    "cancelButton",
  ],
  baseStyle: {
    modalContent: {},
    modalBody: { paddingTop: "20px" },
    jsonContainer: { w: "fit-content", maxW: "360px", marginRight: "20px" },
    hStack: { display: "flex", alignItems: "flex-start" },
    labelHeader: {
      fontStyle: "normal",
      fontWeight: 700,
      fontSize: "18px",
      lineHeight: "28px",
    },
    labelBody: {
      mt: "30px",
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "16px",
      lineHeight: "24px",
      whiteSpace: "pre-wrap",
    },
    cancelButton: {},
  },
};
